import { Component, Output, Input, EventEmitter, OnInit, ViewChild, TemplateRef, OnDestroy, ComponentFactoryResolver } from "@angular/core";
import * as $ from 'jquery';
//import * as faceapi from '../../../assets/face-track/face-api.min.js';
import * as faceapi from 'face-api.js';
import { ngxLoadingAnimationTypes, NgxLoadingComponent } from 'ngx-loading';
import { DomSanitizer } from '@angular/platform-browser';

import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import Swal from 'sweetalert2';
import { Global } from '../../global';
import { ApiService } from '../../services/api.service';
import { Router, NavigationStart, NavigationEnd, ActivatedRoute, Event as NavigationEvent } from "@angular/router";
import { FormBuilder, Validators } from '@angular/forms';
import { Observable, Observer } from "rxjs";
import { saveAs } from 'file-saver';

const PrimaryWhite = '#fff';
const SecondaryGrey = '#ccc';

@Component({
  selector: 'app-reconhece-rosto',
  templateUrl: './reconhece-rosto.component.html',
  styleUrls: ['./reconhece-rosto.component.css']
})
export class ReconheceRostoComponent implements OnInit, OnDestroy {
  MODELS_URL: string = "../../../assets/face-track/models/";
  foto: boolean = false;
  contador: number;
  interval: any = null;
  timer: any = null;
  counter: any = null;
  startVideo: boolean = false;
  loaded: boolean = false;

  currentUser: any = {};
  funcionario: any = {};
  retornoPresenca: any;

  name = "Angular";
  base64TrimmedURL: string;
  base64DefaultURL: string;
  generatedImage: any;
  windowOPen: boolean;
  regPonto: any = {};
  position: any = {
    latitude: 0, longitude: 0, accuracy: 0
  };

  realizarPonto: any = {};
  uriPresenca: string = "https://apipresenca.nusacontrol.com.br/file";

  public formGroup = this.fb.group({
    file: [null, Validators.required]
  });

  @ViewChild('video') video: any;
  @ViewChild('canvas') canvas: any;
  @Output() retornarFiltro = new EventEmitter<boolean>();
  @Output() LoadFN = new EventEmitter<boolean>();
  @Input() setorUuid: Object;
  @Input() setorNome: Object;
  @Input() unidadeUuid: Object;
  @Input() unidadeNome: Object;

  @ViewChild('ngxLoading') ngxLoadingComponent: NgxLoadingComponent;
  @ViewChild('customLoadingTemplate') customLoadingTemplate: TemplateRef<any>;

  public ngxLoadingAnimationTypes = ngxLoadingAnimationTypes;
  public loading = true;
  public primaryColour = PrimaryWhite;
  public secondaryColour = SecondaryGrey;
  public coloursEnabled = false;
  public loadingTemplate: TemplateRef<any>;
  public config = {
    animationType: ngxLoadingAnimationTypes.circle,
    primaryColour: this.primaryColour,
    secondaryColour: this.secondaryColour,
    tertiaryColour: this.primaryColour,
    backdropBorderRadius: '3px'
  };

  constructor(
    private sanitizer: DomSanitizer,
    private apiService: ApiService,
    public global: Global,
    public dialog: MatDialog,
    private router: Router,
    private fb: FormBuilder,
  ) {
    try {
      if (localStorage.getItem("currentUser") == null)
        this.router.navigate(["/login"]);
      this.currentUser = JSON.parse(localStorage.getItem("currentUser"));
    } catch (err) {
      this.router.navigate(["/login"]);
    }
  }

  async ngOnInit() {
    $("div.counter").css("display", "none");
    this.LoadFN.emit();

    this.getFuncionario();
    Promise.all([
      await this.openCamera(),
      await this.fnLocation(),
    ]).then(() => {
      this.cancelaLoad();
    });
    // let faceapi_ = faceapi;
    // Promise.all([
    //   await faceapi_.loadTinyFaceDetectorModel(this.MODELS_URL),
    //   await faceapi_.loadFaceLandmarkModel(this.MODELS_URL),
    //   await faceapi_.loadFaceRecognitionModel(this.MODELS_URL),
    //   await faceapi_.loadFaceExpressionModel(this.MODELS_URL),
    // ]).then(() => { this.openCamera(); });
  }

  async ngOnDestroy() {
    const video = this.video.nativeElement;
    const stream = video.srcObject;
    const tracks = stream.getTracks();
    tracks.forEach((track) => {
      track.stop();
    });
    const canvas = faceapi.createCanvasFromMedia(video);
    if (canvas) {
      $("canvas").remove();
    }
    if ($("#trackFace").length > 0) {
      $("canvas#trackFace").remove();
    }
    clearInterval(this.interval);
    //video.removeEventListener('play',this.trackFace());
    const detections = null;
    const resizedDetections = null;
  }

  openCamera = () => { //obter vídeo da câmera!
    if ($("#fotoTirada").length > 0) {
      $("canvas#fotoTirada").remove();
      $("canvas#fotoTirada").getContext('2d').clearRect(0, 0, $("canvas#fotoTirada").width, $("canvas#fotoTirada").height)
    }
    if ($("#photoRegister").length > 0) {
      $("img#photoRegister").remove();
    }
    $("div.counter").css("display", "none");
    this.foto = false;
    const video = this.video.nativeElement;
    var n = <any>navigator;
    n.getUserMedia = (n.getUserMedia || n.webkitGetUserMedia || n.mozGetUserMedia || n.msGetUserMedia);
    n.mediaDevices.getUserMedia({ video: true }).then(function (stream) { video.srcObject = stream; });
    if ($(".body").not(video)) {
      $(".body").append(video);
      if ($(video).length > 0) {
        $(video).attr("id", "video");
        $(video).attr("width", "400");
        $(video).attr("height", "400");
        $(video).attr("autoplay");
        $(video).attr("muted");
        $(video).attr("#video");
        $(video).css("margin", "15px");
      }
    }
  }

  cancelaLoad = () => {
    this.LoadFN.emit();
  }

  trackFace = () => { //rastrear rosto
    const video = this.video.nativeElement;
    var n = <any>navigator;
    n.getUserMedia = (n.getUserMedia || n.webkitGetUserMedia || n.mozGetUserMedia || n.msGetUserMedia);
    n.mediaDevices.getUserMedia({ video: true }).then(function (stream) { video.srcObject = stream; });
    video.addEventListener('play', () => {
      const canvas = faceapi.createCanvasFromMedia(video);
      if ($("canvas#trackFace").length == 0) {
        $(".body").append(canvas);
        const displaySize = { width: video.width, height: video.height };
        faceapi.matchDimensions(canvas, displaySize);
        $("canvas").css("position", "absolute");
        $("canvas").attr("id", "trackFace");
        this.interval = setInterval(async () => {
          const detections = await faceapi.detectSingleFace(video, new faceapi.TinyFaceDetectorOptions())
          const resizedDetections = faceapi.resizeResults(detections, displaySize)
          canvas.getContext('2d').clearRect(0, 0, canvas.width, canvas.height)
          faceapi.draw.drawDetections(canvas, resizedDetections)
        }, 500);
      }
      else if ($("canvas#trackFace").length > 1) {
        return
      }
    });
  }

  takePicture = () => { //capturar frame do video
    this.foto = true;
    $("canvas#trackFace").remove();
    if ($("canvas#fotoTirada").length == 0) {
      const video = this.video.nativeElement;
      const canvas = faceapi.createCanvasFromMedia(video);
      if (canvas) {
        $(".body").append(canvas);
        $("canvas").css("position", "absolute");
        $("canvas").attr("id", "fotoTirada");
        const stream = video.srcObject;
        const tracks = stream.getTracks();
        tracks.forEach(function (track) {
          track.stop();
        });
        video.srcObject = null;
        if ($("video").length > 0) {
          $("video").remove();
        }
        clearTimeout(this.timer);
        this.contador = 5;
        $("div.counter").css("display", "none");
        video.removeEventListener('play', () => { });
        this.convertPix();
      } else if ($("canvas#fotoTirada").length > 1) {
        return
      }
    }
    else return;
  }

  convertPix = () => { //converter em img jpg
    var convert = $("canvas#fotoTirada");
    var dataUrl = convert[0].toDataURL("image/png", 1);
    if (dataUrl) {
      $("canvas#fotoTirada").remove();
      $('.body').prepend($('<img>', { id: 'photoRegister', src: dataUrl, width: "400", height: "400", }))
      $('img').css("padding-bottom", "15px")
      $('img').css("object-fit", "cover")
      $('img').css("transform", "scaleX(-1)")

    }
    this.getImage(dataUrl);
  }

  voltarPagina = (value: false) => {
    if ($("#trackFace").length > 0) {
      $("canvas#trackFace").remove();
    }
    if ($("#fotoTirada").length > 0) {
      $("canvas#fotoTirada").remove();
    }
    if ($("video").length > 0) {
      const video = this.video.nativeElement;
      const stream = video.srcObject;
      const tracks = stream.getTracks();
      tracks.forEach(function (track) {
        track.stop();
      });
      video.srcObject = null;
    }
    this.retornarFiltro.emit(value);
  }

  restart = () => {
    this.startVideo = false;
    if ($("#fotoTirada").length > 0) {
      $("canvas#fotoTirada").remove();
      $("canvas#fotoTirada").getContext('2d').clearRect(0, 0, $("canvas#fotoTirada").width, $("canvas#fotoTirada").height)
    }
    const video = this.video.nativeElement;
    video.removeEventListener('play', this.trackFace);
    this.openCamera();
  }

  startTimer = () => {
    $("span.click").css("display", "none");
    $("span.contador").css("display", "block");
    $("div.counter").removeAttr("style");
    this.contador = 3;
    this.counter = setInterval(() => {
      if (this.contador <= 0) {
        clearInterval(this.counter);
        $("div.counter").css("display", "flex").css("color", "#fff");
        this.click();
      }
      this.contador -= 1;
    }, 1000);
  }

  click = () => {
    if ($("#trackFace").length > 0) {
      $("canvas#trackFace").remove();
    }
    $("div.counter").css("background-color", "#fff");
    $("span.contador").css("display", "none");
    $("span.click").css("display", "block").css("color", "#000");
    this.contador = 1;
    this.counter = setInterval(() => {
      if (this.contador <= 0) {
        clearInterval(this.counter);
        $("div.counter").css("display", "none");
        this.takePicture();
      }
      this.contador -= 1;
    }, 250);
  }

  callPresenca = (img) => {
    this.loading = true;
    this.apiService.PostPresenca('Files/Presenca/uuid=' + this.currentUser.uuid,).then(
      result => {
        this.loading = false;
        this.retornoPresenca = result;
      },
      err => {
        this.loading = false;
        if (err.status == 401) {
          this.router.navigate(["/login"]);
          return;
        }
        Swal.fire({
          type: 'error',
          title: 'Oops...',
          text: err.error.mensagem
        });
      }
    );

  }

  /* Method to fetch image from Url */
  getBase64ImageFromURL(url: string): Observable<string> {
    return Observable.create((observer: Observer<string>) => {
      // create an image object
      let img = new Image();
      img.crossOrigin = "Anonymous";
      img.src = url;
      if (!img.complete) {
        // This will call another method that will create image from url
        img.onload = () => {
          observer.next(this.getBase64Image(img));
          observer.complete();
        };
        img.onerror = err => {
          observer.error(err);
        };
      } else {
        observer.next(this.getBase64Image(img));
        observer.complete();
      }
    });
  }

  /* Method to create base64Data Url from fetched image */
  getBase64Image(img: HTMLImageElement): string {
    // We create a HTML canvas object that will create a 2d image
    var canvas: HTMLCanvasElement = document.createElement("canvas");
    canvas.width = 400;
    canvas.height = 400;
    let ctx: CanvasRenderingContext2D = canvas.getContext("2d");
    // This will draw image
    ctx.drawImage(img, -120, 0);
    // Convert the drawn image to Data URL
    let dataURL: string = canvas.toDataURL("image/png");
    this.base64DefaultURL = dataURL;
    return dataURL.replace(/^data:image\/(png|jpg);base64,/, "");
  }

  getImage(imageUrl: string) {
    this.LoadFN.emit();
    this.windowOPen = true;
    this.getBase64ImageFromURL(imageUrl).subscribe((base64Data: string) => {
      this.base64TrimmedURL = base64Data;
      this.createBlobImageFileAndShow();
    });
  }

  /** 1a etapa de bater ponto: conversão da foto */
  createBlobImageFileAndShow(): void {
    this.dataURItoBlob(this.base64TrimmedURL).subscribe((blob: Blob) => {
      const imageBlob: Blob = blob;
      const imageName: string = 'ponto';
      const imageFile: File = new File([imageBlob], imageName, {
        type: "image/png"
      });
      this.generatedImage = imageFile;
      if (this.generatedImage) {
        this.loading = true;
        this.apiService.pushFileToStorage(imageFile, 'Files/Presenca/' + this.funcionario.presenca_uuid).then(
          result => {
            this.loading = false;
            this.retornoPresenca = result;
            if (this.retornoPresenca.status === 200) {
              this.realizaPonto();
            }
          },
          err => {
            this.loading = false;
            this.LoadFN.emit();
            if (err.status == 401) {
              this.router.navigate(["/login"]);
              return;
            }
            Swal.fire({
              type: 'error',
              title: 'Oops...',
              text: err.error.mensagem
            });
          }
        );
        //this.loading = false;
      }
    });
  }

  /**Method to Generate a Name for the Image */
  generateName(): string {
    const date: number = new Date().valueOf();
    let text: string = "";
    const possibleText: string =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    for (let i = 0; i < 6; i++) {
      text += possibleText.charAt(
        Math.floor(Math.random() * possibleText.length)
      );
    }
    // Replace extension according to your media type like this
    var xyz = text + ".png";
    console.log(xyz);
    return text + ".png";
  }

  /* Method to convert Base64Data Url as Image Blob */
  dataURItoBlob(dataURI: string): Observable<Blob> {
    return Observable.create((observer: Observer<Blob>) => {
      const byteString: string = window.atob(dataURI);
      const arrayBuffer: ArrayBuffer = new ArrayBuffer(byteString.length);
      const int8Array: Uint8Array = new Uint8Array(arrayBuffer);
      for (let i = 0; i < byteString.length; i++) {
        int8Array[i] = byteString.charCodeAt(i);
      }
      const blob = new Blob([int8Array], { type: "image/jpeg" });
      observer.next(blob);
      observer.complete();
    });
  }

  /** 2a etapa de bater ponto: obtenção dos dados do ponto */
  realizaPonto = () => {
    this.loading = true;

    var dataHoje = new Date();
    dataHoje = new Date(dataHoje.valueOf() - dataHoje.getTimezoneOffset() * 60000);
    this.regPonto.presenca_em = dataHoje.toISOString();
    // this.regPonto.presenca_em = dataHoje.toISOString().replace(/\.\d{3}Z$/, '');

    this.regPonto.presenca_uuid = this.funcionario.presenca_uuid;
    this.regPonto.registro = this.retornoPresenca.error.text;
    this.regPonto.latitude = this.position.latitude;
    this.regPonto.longitude = this.position.longitude;
    this.regPonto.precisao = this.position.accuracy;
    this.regPonto.status = "APROVADO";
    this.regPonto.funcionario_uuid = this.funcionario.uuid;
    this.regPonto.unidade_uuid = this.unidadeUuid;
    this.regPonto.setor_uuid = this.setorUuid;

    this.compararPonto();
  }

  fnLocation = () => {
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition((position) => {
        this.position = position.coords;
      });
    }
  }

  compararPonto = () => {
    let usuario = this.regPonto.presenca_uuid;
    let registro = this.regPonto.registro;
    this.realizarPonto.url_conhecida = this.funcionario.foto_perfil;
    this.realizarPonto.url_desconhecida = `${this.uriPresenca}/${usuario}/presenca/${registro}`;
    //console.log(this.realizarPonto);

    this.apiService.PostReconhecimento('ReconhecimentoFacial', this.realizarPonto).then(
      result => {
        var retorno = result;
        if (retorno["aprovado"] == true) {
          this.finalizarPonto();
        }

        else if (retorno["aprovado"] == false) {
          this.loading = false;
          Swal.fire({
            type: 'error',
            title: 'Houve falha no ponto',
            text: 'A imagem não foi reconhecida. Verifique se o login está correto'
          });
          this.LoadFN.emit();
          this.loaded = true;
        }
      },
      err => {
        if (err.status == 401) {
          this.router.navigate(["/login"]);
          this.loading = false;
          return;
        }
        this.loading = false;
        Swal.fire({
          type: 'error',
          title: 'Houve falha no ponto',
          text: err.error.mensagem
        });
        this.LoadFN.emit();
        this.loaded = true;
      }
    )
  }

  getFuncionario() {
    this.loading = true;
    this.apiService.GetOne("Funcionarios", this.currentUser.uuid).then(
      result => {
        this.loading = false;
        this.funcionario = result;
      },
      err => {
        this.loading = false;
        if (err.status == 401) {
          this.router.navigate(["/login"]);
          return;
        }
        Swal.fire({
          type: 'error',
          title: 'Oops...',
          text: err.error.mensagem
        });
      }
    );
    this.loading = false;
  }

  finalizarPonto = () => {
    this.apiService.PostFinalizarPonto('Pontos', this.regPonto).then(
      result => {
        // console.log(result);
        this.LoadFN.emit();
        this.loaded = true;
        Swal.fire({
          type: 'success',
          title: 'Ponto realizado com sucesso',
        }).then((result) => {
          if (result) {
            this.loading = false;
            this.voltarPagina(false);
          }
        });
      },
      error => {
        this.loading = false;
        if(error.mensagem){
          Swal.fire('Oops', error.mensagem, 'error');
        }
        if(error.error.mensagem){
          Swal.fire('Oops', error.error.mensagem, 'error');
        }
        Swal.fire('Oops', error.toString(), 'error');
      }
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/components/reconhece-rosto/reconhece-rosto.component.ts